import { CardDataProps } from "../pages/AISignals/TradeCardRows/TradeCardsRow";
import api from "./api";

export const getSmartCardInfo = (card: string) => {
  return api.get(`/card/smart-card-info?filter=${card}`);
};

export const getSmartCardInfoDexGem = (id: any) => {
  return api.get(`/project/smart-card?category_id=${id}`);
};

export const getTopGainerInfo = (card: string) => {
  return api.get(`/card/top-gainer?filter=${card}`);
};
export const getTopGainerInfoDexGem = (id: any) => {
  return api.get(`/project/top-gainers?category_id=${id}`);
};


export const getTopComments = (card: string) => {
  return api.get(`/trading-view/engaging/comment?cardType=${card}`);
};

export const getWatchlistAi = (card: string) => {
  return api.get(`/card/watchlist-count?category=${card}`);
};

export const getExchanges = () => {
  return api.get(`card/exchange?crypto=true`);
};

export const getCards = (query: string) => {
  return api.get(`card/${query}`);
};

export const addWatchList = (data: CardDataProps) => {
  if (data.watch_list_status === 1) {
    return api.delete(`card-bookmark/${data.id ? data.id : data.ID}`);
  } else {
    return api.post(`card-bookmark/${data.id ? data.id : data.ID}`,{});
  }
};

export const getTradeView = (tradingViewId: string) => {
  return api.get(`trading-view/${tradingViewId}`);
};

export interface IActiveCardParams {
  marketType: string;
  coinPair: string;
}

export const getActiveCard = (data: IActiveCardParams) => {
  return api.get(
    `trading-view/active-card?market=${data.marketType}&pair=${data.coinPair}&count=3`
  );
};

export const getAppreciateDetails = (tradingViewId: string) => {
  let apiUrl = `trading-view/appreciation?trading_view_id=${tradingViewId}`;
  return api.get(apiUrl);
};

export interface IUpdateRatingParams {
  trading_view_id: number;
  ratings: number;
}

export const updateRatings = (ratingInfo: IUpdateRatingParams) => {
  return api.post(`trading-view/manage-appreciation`, {
    ...ratingInfo,
    appreciate_type: "ratings",
  });
};

export const updateComments = (apiData: FormData) => {
  return api.post("/comment", apiData);
};

export const getComments = ({ apiParams, table }: { apiParams: string, table: string }) => {
  let apiUrl = `comment?table=${table}&${apiParams}`;
  return api.get(apiUrl);
};
export const updateLike = ({
  apiData,
  table_id,
}: {
  apiData: any;
  table_id: any;
}) => {
  return api.post("/like", {
    ...apiData,
    table_id,
    table: "trading_views",
  });
};

export const getAppreciates = (trade_view_id: number) => {
  return api.get(
    `trading-view/appreciation?trading_view_id=${trade_view_id}`
  );
};

export interface IUpdateAppreciate {
  appreciate_state: boolean;
  trading_view_id: number;
}

export const updateAppreciation = (apiData: IUpdateAppreciate) => {
  return api.post(`trading-view/manage-appreciation`, {
    ...apiData,
    appreciate_type: "appreciate",
  });
};

export interface ISimilarMarketProps {
  marketType: string;
  market: string;
  view_id: number;
}

export const getSimilarMarket = ({
  market,
  marketType,
  view_id,
}: ISimilarMarketProps) => {
  let apiUrl = `trading-view/similar?market=${marketType}&view=${market}&view_id=${view_id}&count=2`;
  return api.get(apiUrl)
};
